<template>
  <div class="acoustic-resonance-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>λ_n = 2L / n (两端固定)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Tube / String -->
          <rect x="50" y="115" width="300" height="10" fill="#333" stroke="#888" />
          
          <!-- Standing Wave nodes/antinodes -->
          <path :d="standingWavePath" fill="none" stroke="#ffd700" stroke-width="2" opacity="0.8" />
          <path :d="standingWavePathInverted" fill="none" stroke="#ffd700" stroke-width="1" opacity="0.3" stroke-dasharray="2" />

          <!-- Nodes markers -->
          <circle v-for="n in nodePositions" :key="'node'+n" :cx="n" cy="120" r="3" fill="#ff4757" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>谐波次数 n: {{ harmonic }}</label>
              <div class="value">波节 总数: {{ harmonic + 1 }}</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>选择谐波</label>
             <el-radio-group v-model="harmonic" size="mini">
                <el-radio-button :label="1">n=1 (基音)</el-radio-button>
                <el-radio-button :label="2">n=2</el-radio-button>
                <el-radio-button :label="3">n=3</el-radio-button>
                <el-radio-button :label="4">n=4</el-radio-button>
             </el-radio-group>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当两列频率相同、振幅相同且传播方向相反的波叠加时，会形成**驻波**。某些点由于干涉始终保持静止（波节），而另一些点振幅最大（波腹）。这是乐器发出特定音高（谐音）的物理基础。长度 $L$ 决定了允许生成的特定波长。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AcousticResonanceViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      harmonic: 1,
      time: 0,
      timer: null
    }
  },
  computed: {
    standingWavePath() {
      let L = 300;
      let amp = 40 * Math.sin(this.time);
      let d = "M 50 120 ";
      for (let x = 0; x <= L; x += 5) {
        let y = 120 + amp * Math.sin((this.harmonic * Math.PI * x) / L);
        d += `L ${50 + x} ${y} `;
      }
      return d;
    },
    standingWavePathInverted() {
      let L = 300;
      let amp = -40 * Math.sin(this.time);
      let d = "M 50 120 ";
      for (let x = 0; x <= L; x += 5) {
        let y = 120 + amp * Math.sin((this.harmonic * Math.PI * x) / L);
        d += `L ${50 + x} ${y} `;
      }
      return d;
    },
    nodePositions() {
      let pos = [];
      let L = 300;
      for (let i = 0; i <= this.harmonic; i++) {
        pos.push(50 + (i * L) / this.harmonic);
      }
      return pos;
    }
  },
  methods: {
    animate() {
      this.time += 0.1;
      this.timer = requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.acoustic-resonance-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
